// takes strings and/or objects in format { [className]: boolean }
// and returns a string with space separated class names suitable
export function classes(...args: Array<any>) {
  let output: string[] = [];
  args.forEach(arg => {
    if (typeof arg === 'string') {
      output.push(arg);
    } else if (typeof arg === 'object') {
      output.push(...Object.keys(arg).filter(key => Boolean(arg[key])));
    }
  });
  return output.join(' ');
}

// strip <script> tags from strings containing HTML
export function sanitizeHtmlString(text?: string | null) {
  if (!text) {
    return '';
  }
  return text.replace(/<\/?script>/gi, '');
}